module.exports = __webpack_public_path__ + "img/1.212d5e98.jpg";